import { formatExperienceSearchSort } from './formatExperienceSearchSort'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import { buildCommittedStateExpiresAt } from 'tripPlanner/assistant/surfaceSnapshots/expiry'
import type { TripPlannerCommittedStateEntry } from 'tripPlanner/assistant/surfaceSnapshots/committedStateEntry'
import { formatExperienceSearchDisplayText, type ExperienceSearchDateRange } from './formatExperienceSearchDisplayText'

// Retain one last search per stop, plus one explicit stopless scope.
export function buildLastExperienceSearchCommittedStateEntry(
  stopId: number | undefined,
  searchQuery: string,
  dateRange: ExperienceSearchDateRange,
  sort: Experiences.SortTypes = 'type',
): TripPlannerCommittedStateEntry {
  return {
    key: stopId === undefined ? 'search:experience:unscoped' : `search:experience:stop:${stopId}`,
    kind: 'last_experience_search',
    label: 'Last experience search',
    displayText: boundActivityDisplayText(formatExperienceSearchDisplayText(searchQuery, dateRange, sort)),
    fields: [{ key: 'sort', value: formatExperienceSearchSort(sort), dataClassification: 'personalised_surface' }],
    sourcePath: 'trip_planner.search.experience',
    dataClassification: 'personalised_surface',
    expiresAt: buildCommittedStateExpiresAt(),
  }
}
